import script from "./ProcedureSections.vue?vue&type=script&setup=true&lang=js"
export * from "./ProcedureSections.vue?vue&type=script&setup=true&lang=js"

import "./ProcedureSections.vue?vue&type=style&index=0&id=070f9f7d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-070f9f7d"]])

export default __exports__